import React from 'react';

import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-date-range/dist/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-date-range/dist/theme/default.css';
// import '@fullcalendar/common/main.min.css';
// import '@fullcalendar/daygrid/main.min.css';
import 'react-phone-input-2/lib/style.css'
import 'react-circular-progressbar/dist/styles.css';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-vis/dist/style.css';
import 'scss/main.scss';
import './i18n';
import './globals';
import Main from 'components/Main';
import CacheBuster from 'cache-buster';

function App() {
  return (
    <CacheBuster>
      <Main></Main>
    </CacheBuster>
  );
}

export default App;